/* ==========================================================================
   tws-cart-guard.js — v1 (18/08/2026)
   --------------------------------------------------------------------------
   Supprime automatiquement du panier les lignes d'option devenues orphelines.

   Le problème : la gravure (24,90 €) et les extensions de garantie sont des
   lignes de panier distinctes du produit auquel elles se rattachent. Si le
   client supprime la montre, ces lignes restaient seules — il pouvait payer
   24,90 € de gravure sans montre.

   La détection ne repose sur aucune liste de produits en dur. Chaque ligne
   d'option porte une propriété « Pour » contenant le titre du produit parent
   (posée par product-bump.js à l'ajout au panier). Une ligne dont le « Pour »
   ne correspond à aucun autre article du panier est orpheline.

   Conséquence : ajouter une nouvelle option demain ne demandera aucune
   modification ici, tant qu'elle pose la propriété « Pour ».

   Chargé sur toutes les pages via layout/theme.liquid : le retrait peut se
   faire depuis le tiroir panier comme depuis la page /cart.
   ========================================================================== */

(function () {
  'use strict';

  if (window.__twsCartGuard) return;
  window.__twsCartGuard = true;

  var PROPRIETE_PARENT = 'Pour';
  var occupe = false;
  var minuteur = null;

  function urlChange() {
    return (window.routes && window.routes.cart_change_url) || '/cart/change';
  }

  function panier() {
    return fetch('/cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.ok ? r.json() : null; });
  }

  /* Une ligne est orpheline si elle porte « Pour » et qu'aucun article
     du panier ne porte ce titre. */
  function orphelines(cart) {
    if (!cart || !cart.items || !cart.items.length) return [];

    var parents = [];
    var options = [];

    cart.items.forEach(function (item) {
      var props = item.properties || {};
      if (props[PROPRIETE_PARENT]) options.push(item);
      else parents.push(item);
    });

    if (!options.length) return [];

    var titres = parents.map(function (i) {
      return String(i.product_title || '').trim();
    });

    return options.filter(function (o) {
      var attendu = String(o.properties[PROPRIETE_PARENT] || '').trim();
      return attendu !== '' && titres.indexOf(attendu) === -1;
    });
  }

  function supprimer(cle, sections) {
    var corps = { id: cle, quantity: 0 };
    if (sections) {
      corps.sections = sections;
      corps.sections_url = window.location.pathname;
    }
    return fetch(urlChange(), {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(corps)
    }).then(function (r) { return r.ok ? r.json() : null; });
  }

  /* Rafraîchit l'affichage sans ouvrir le tiroir de force. */
  function rafraichir(reponse) {
    if (window.location.pathname.indexOf('/cart') === 0) {
      window.location.reload();
      return;
    }

    var tiroir = document.querySelector('cart-drawer');

    if (tiroir && tiroir.classList.contains('active') && reponse && reponse.sections) {
      try { tiroir.renderContents(reponse); return; } catch (e) { /* on retombe sur la pastille */ }
    }

    if (reponse && reponse.sections && reponse.sections['cart-icon-bubble']) {
      var pastille = document.getElementById('cart-icon-bubble');
      if (pastille) {
        try {
          pastille.innerHTML = new DOMParser()
            .parseFromString(reponse.sections['cart-icon-bubble'], 'text/html')
            .querySelector('.shopify-section').innerHTML;
        } catch (e) { /* silencieux */ }
      }
    }
  }

  function verifier() {
    if (occupe) return;
    occupe = true;

    panier()
      .then(function (cart) {
        var aSupprimer = orphelines(cart);
        if (!aSupprimer.length) return null;

        console.info('[TWS] option(s) orpheline(s) retirée(s) du panier :',
          aSupprimer.map(function (i) { return i.title; }).join(', '));

        /* Suppression séquentielle : les clés de ligne changent à chaque appel. */
        var chaine = Promise.resolve(null);
        aSupprimer.forEach(function (item, i) {
          var dernier = i === aSupprimer.length - 1;
          chaine = chaine.then(function () {
            return supprimer(item.key, dernier ? ['cart-drawer', 'cart-icon-bubble'] : null);
          });
        });
        return chaine;
      })
      .then(function (reponse) {
        if (reponse) rafraichir(reponse);
      })
      .catch(function (e) { console.warn('[TWS cart guard]', e); })
      .finally(function () { occupe = false; });
  }

  function verifierBientot() {
    clearTimeout(minuteur);
    minuteur = setTimeout(verifier, 500);
  }

  function demarrer() {
    verifier();

    /* Le thème remplace l'intérieur du tiroir à chaque modification du panier :
       on observe ce conteneur plutôt que d'intercepter les appels réseau. */
    var cible = document.getElementById('CartDrawer') || document.querySelector('cart-drawer');
    if (cible && window.MutationObserver) {
      new MutationObserver(verifierBientot).observe(cible, { childList: true, subtree: true });
    }

    /* Page panier classique : pas de tiroir, on écoute les formulaires. */
    document.addEventListener('change', function (e) {
      if (e.target && e.target.name === 'updates[]') verifierBientot();
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', demarrer, { once: true });
  } else {
    demarrer();
  }
})();
